
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/var/canvas/ui/shared/spinner/jst/_spinner.handlebars";
import "/var/canvas/ui/shared/external-tools/jst/_external_tools_menu.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/assignment-index/jst/AssignmentListItem';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, self=this, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";

function program1(depth0,data) {
  
  
  return "ig-published";
  }

function program3(depth0,data) {
  
  
  return "is-master";
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"ig-row__layout\">\n      ";
  stack1 = self.invokePartial(partials['ui/shared/spinner/jst/_spinner.handlebars'], 'ui/shared/spinner/jst/_spinner.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'originalAssignmentName': ((depth0 && depth0.originalAssignmentName)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "making_a_copy_of_originalassignmentname_b7268992", "Making a copy of \"%{originalAssignmentName}\"", options) : helperMissing.call(depth0, "t", "making_a_copy_of_originalassignmentname_b7268992", "Making a copy of \"%{originalAssignmentName}\"", options)))
    + "\n    </div>\n  ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.failedToDuplicate), {hash:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <span aria-live=\"polite\" role=\"alert\" aria-atomic=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'originalAssignmentName': ((depth0 && depth0.originalAssignmentName)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "oops_something_went_wrong_with_making_a_copy_of_or_7e9d6695", "Oops! Something went wrong with making a copy of \"%{originalAssignmentName}\"", options) : helperMissing.call(depth0, "t", "oops_something_went_wrong_with_making_a_copy_of_or_7e9d6695", "Oops! Something went wrong with making a copy of \"%{originalAssignmentName}\"", options)))
    + "</span>\n    <div class=\"duplicate-failed-actions\">\n      <button class=\"duplicate-failed-retry btn btn-primary\">\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'originalAssignmentName': ((depth0 && depth0.originalAssignmentName)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "retry_duplicating_originalassignmentname_884aee1", "Retry duplicating \"%{originalAssignmentName}\"", options) : helperMissing.call(depth0, "t", "retry_duplicating_originalassignmentname_884aee1", "Retry duplicating \"%{originalAssignmentName}\"", options)))
    + "</span>\n        <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "retry_ebd5f8ba", "Retry", options) : helperMissing.call(depth0, "t", "retry_ebd5f8ba", "Retry", options)))
    + "</span>\n      </button>\n      <button class=\"duplicate-failed-cancel btn\">\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'originalAssignmentName': ((depth0 && depth0.originalAssignmentName)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "cancel_duplicating_originalassignmentname_fd7ee1d8", "Cancel duplicating \"%{originalAssignmentName}\"", options) : helperMissing.call(depth0, "t", "cancel_duplicating_originalassignmentname_fd7ee1d8", "Cancel duplicating \"%{originalAssignmentName}\"", options)))
    + "</span>\n        <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "</span>\n      </button>\n    </div>\n  ";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isMigrating), {hash:{},inverse:self.program(13, program13, data),fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"ig-row__layout\">\n      ";
  stack1 = self.invokePartial(partials['ui/shared/spinner/jst/_spinner.handlebars'], 'ui/shared/spinner/jst/_spinner.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "migrating_name_e05aa53e", "Migrating \"%{name}\"", options) : helperMissing.call(depth0, "t", "migrating_name_e05aa53e", "Migrating \"%{name}\"", options)))
    + "\n    </div>\n  ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.failedToMigrate), {hash:{},inverse:self.program(16, program16, data),fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }
function program14(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <span aria-live=\"polite\" role=\"alert\" aria-atomic=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "oops_something_went_wrong_with_migrating_name_acdbc98b", "Oops! Something went wrong with migrating \"%{name}\"", options) : helperMissing.call(depth0, "t", "oops_something_went_wrong_with_migrating_name_acdbc98b", "Oops! Something went wrong with migrating \"%{name}\"", options)))
    + "</span>\n    <div class=\"migrate-failed-actions\">\n      <button class=\"migrate-failed-retry btn btn-primary\">\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "retry_migrating_name_bdc802ef", "Retry migrating \"%{name}\"", options) : helperMissing.call(depth0, "t", "retry_migrating_name_bdc802ef", "Retry migrating \"%{name}\"", options)))
    + "</span>\n        <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "retry_ebd5f8ba", "Retry", options) : helperMissing.call(depth0, "t", "retry_ebd5f8ba", "Retry", options)))
    + "</span>\n      </button>\n      <button class=\"duplicate-failed-cancel btn\">\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "cancel_migrating_name_cfc745c2", "Cancel migrating \"%{name}\"", options) : helperMissing.call(depth0, "t", "cancel_migrating_name_cfc745c2", "Cancel migrating \"%{name}\"", options)))
    + "</span>\n        <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "</span>\n      </button>\n    </div>\n  ";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isImporting), {hash:{},inverse:self.program(19, program19, data),fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }
function program17(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"ig-row__layout\">\n      ";
  stack1 = self.invokePartial(partials['ui/shared/spinner/jst/_spinner.handlebars'], 'ui/shared/spinner/jst/_spinner.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "importing_name_8f2b131d", "Importing \"%{name}\"", options) : helperMissing.call(depth0, "t", "importing_name_8f2b131d", "Importing \"%{name}\"", options)))
    + "\n    </div>\n  ";
  return buffer;
  }

function program19(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.failedToImport), {hash:{},inverse:self.program(22, program22, data),fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  }
function program20(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <span aria-live=\"polite\" role=\"alert\" aria-atomic=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "oops_something_went_wrong_importing_name_d382cac1", "Oops! Something went wrong importing \"%{name}\"", options) : helperMissing.call(depth0, "t", "oops_something_went_wrong_importing_name_d382cac1", "Oops! Something went wrong importing \"%{name}\"", options)))
    + "</span>\n    <div class=\"import-failed-actions\">\n      <button class=\"import-failed-cancel btn\">\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "cancel_importing_name_a0b6f3e1", "Cancel importing \"%{name}\"", options) : helperMissing.call(depth0, "t", "cancel_importing_name_a0b6f3e1", "Cancel importing \"%{name}\"", options)))
    + "</span>\n        <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "</span>\n      </button>\n    </div>\n  ";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    <div class=\"ig-row__layout\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <div class=\"ig-type-icon\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isMasteryConnectTool), {hash:{},inverse:self.program(31, program31, data),fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <span class=\"screenreader-only\">";
  if (helper = helpers.objectTypeDisplayName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.objectTypeDisplayName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n    </div>\n    <div class=\"ig-info\">\n      <a href=\"";
  if (helper = helpers.htmlUrl) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.htmlUrl); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"ig-title\" aria-live=\"polite\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.quizzesRespondusEnabled), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n        ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n      </a>\n      <div class=\"ig-details\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(35, program35, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showAvailability), {hash:{},inverse:self.noop,fn:self.program(43, program43, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showDueDate), {hash:{},inverse:self.noop,fn:self.program(45, program45, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.pointsPossible), {hash:{},inverse:self.program(49, program49, data),fn:self.program(47, program47, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isMasteryConnectTool), {hash:{},inverse:self.noop,fn:self.program(51, program51, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canOpenManageOptions), {hash:{},inverse:self.noop,fn:self.program(53, program53, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(86, program86, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program23(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <div aria-hidden='true' class=\"ig-handle\">\n      <span class=\"draggable-handle";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.canMove), {hash:{},inverse:self.noop,fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n        <i class=\"icon-drag-handle\"></i>\n      </span>\n    </div>\n    ";
  return buffer;
  }
function program24(depth0,data) {
  
  
  return " disabled";
  }

function program26(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        <img src=\"/images/icons/";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.program(29, program29, data),fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" alt=\"Mastery Connect\" style=\"width: 1rem; height: 1rem;\"/>\n      ";
  return buffer;
  }
function program27(depth0,data) {
  
  
  return "mc-assignment-pub.svg";
  }

function program29(depth0,data) {
  
  
  return "mc-assignment-unpub.svg";
  }

function program31(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <i aria-hidden=\"true\" class='icon-";
  if (helper = helpers.iconType) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.iconType); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "'></i>\n      ";
  return buffer;
  }

function program33(depth0,data) {
  
  
  return "target=\"_blank\"";
  }

function program35(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.has_modules), {hash:{},inverse:self.noop,fn:self.program(36, program36, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program36(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <div class=\"ig-details__item ig-details__item--wrap-text modules\">\n              ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(39, program39, data),fn:self.program(37, program37, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.module_count), 1, options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.module_count), 1, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              <div id=\"module_tooltip_";
  if (helper = helpers.labelId) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.labelId); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" style=\"display:none;\">\n                ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.modules), {hash:{},inverse:self.noop,fn:self.program(41, program41, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              </div>\n            </div>\n          ";
  return buffer;
  }
function program37(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                ";
  if (helper = helpers.module_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.module_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "module_90d9fd32", "Module", options) : helperMissing.call(depth0, "t", "module_90d9fd32", "Module", options)))
    + "\n              ";
  return buffer;
  }

function program39(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <a\n                  title='";
  if (helper = helpers.joined_names) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.joined_names); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "'\n                  class=\"tooltip_link\"\n                  data-tooltip-selector=\"#module_tooltip_";
  if (helper = helpers.labelId) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.labelId); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n                >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "multiple_modules_930713d4", "Multiple Modules", options) : helperMissing.call(depth0, "t", "multiple_modules_930713d4", "Multiple Modules", options)))
    + "</a>\n              ";
  return buffer;
  }

function program41(depth0,data) {
  
  var buffer = "";
  buffer += "\n                  <span>"
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0))
    + "</span>\n                ";
  return buffer;
  }

function program43(depth0,data) {
  
  
  return "\n        <div class=\"ig-details__item assignment-date-available\" data-view=\"date-available\">\n        </div>\n        ";
  }

function program45(depth0,data) {
  
  
  return "\n          <div class=\"ig-details__item assignment-date-due\" data-view=\"date-due\">\n          </div>\n        ";
  }

function program47(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <div class=\"ig-details__item js-score\">\n            <span class=\"screenreader-only\">\n              ";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.pointsPossible), options) : helperMissing.call(depth0, "n", (depth0 && depth0.pointsPossible), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_pointsPossible': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "n_pointspossible_points_possible_1d098245", "%{n_pointsPossible} Points Possible", options) : helperMissing.call(depth0, "t", "n_pointspossible_points_possible_1d098245", "%{n_pointsPossible} Points Possible", options)))
    + "\n            </span>\n            <span class=\"non-screenreader\" aria-hidden=\"true\">\n              ";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.pointsPossible), options) : helperMissing.call(depth0, "n", (depth0 && depth0.pointsPossible), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_pointsPossible': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "n_pointspossible_pts_73274d36", "%{n_pointsPossible} pts", options) : helperMissing.call(depth0, "t", "n_pointspossible_pts_73274d36", "%{n_pointsPossible} pts", options)))
    + "\n            </span>\n          </div>\n        ";
  return buffer;
  }

function program49(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <span class=\"js-score screenreader-only\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "no_points_possible_368669d", "No Points Possible", options) : helperMissing.call(depth0, "t", "no_points_possible_368669d", "No Points Possible", options)))
    + "\n          </span>\n        ";
  return buffer;
  }

function program51(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          <div class=\"ig-details__item mc-objectives\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.externalToolData)),stack1 == null || stack1 === false ? stack1 : stack1.objectives)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</div>\n        ";
  return buffer;
  }

function program53(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <div class=\"ig-admin\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(54, program54, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        <div class=\"inline-block\">\n          <button\n            class=\"al-trigger al-trigger-gray Button--icon-action\"\n            id=\"assign_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n            tabindex=\"0\"\n          >\n            <i class=\"icon-more\" aria-hidden=\"true\"></i>\n            <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "settings_for_assignment_name_c19565e1", "Settings for Assignment %{name}", options) : helperMissing.call(depth0, "t", "settings_for_assignment_name_c19565e1", "Settings for Assignment %{name}", options)))
    + "</span>\n          </button>\n\n          <ul\n            id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_list\"\n            class=\"al-options\"\n          >\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(59, program59, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.is_locked), {hash:{},inverse:self.noop,fn:self.program(77, program77, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.DIRECT_SHARE_ENABLED), {hash:{},inverse:self.noop,fn:self.program(82, program82, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(84, program84, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </ul>\n        </div>\n      </div>\n      ";
  return buffer;
  }
function program54(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isTrigger), {hash:{},inverse:self.noop,fn:self.program(55, program55, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isReleased), {hash:{},inverse:self.noop,fn:self.program(57, program57, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          <span class=\"sis-button\" data-view=\"sis-button\"></span>\n          <span class=\"lock-icon\" data-view=\"lock-icon\"></span>\n          <span class=\"publish-icon\" data-view=\"publish-icon\"></span>\n        ";
  return buffer;
  }
function program55(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <a href=\"";
  if (helper = helpers.htmlEditUrl) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.htmlEditUrl); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "?return_to=";
  if (helper = helpers.return_to) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.return_to); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "#mastery-paths-editor\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "edit_mastery_paths_for_name_c9fc59f9", "Edit Mastery Paths for %{name}", options) : helperMissing.call(depth0, "t", "edit_mastery_paths_for_name_c9fc59f9", "Edit Mastery Paths for %{name}", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "mastery_paths_cc4096c2", "Mastery Paths", options) : helperMissing.call(depth0, "t", "mastery_paths_cc4096c2", "Mastery Paths", options)))
    + "</a>\n          ";
  return buffer;
  }

function program57(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <span class=\"pill mastery-path-icon\" aria-hidden=\"true\" data-tooltip title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'cyoe.releasedLabel': (((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.releasedLabel)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options) : helperMissing.call(depth0, "t", "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options)))
    + "\">\n              <i class=\"icon-mastery-path\"></i>"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.releasedLabel)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n            </span>\n            <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'cyoe.releasedLabel': (((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.releasedLabel)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options) : helperMissing.call(depth0, "t", "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options)))
    + "</span>\n          ";
  return buffer;
  }

function program59(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canEdit), {hash:{},inverse:self.program(62, program62, data),fn:self.program(60, program60, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canShowBuildLink), {hash:{},inverse:self.noop,fn:self.program(64, program64, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canDuplicate), {hash:{},inverse:self.noop,fn:self.program(69, program69, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canMove), {hash:{},inverse:self.program(73, program73, data),fn:self.program(71, program71, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isCyoeAble), {hash:{},inverse:self.noop,fn:self.program(75, program75, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  return buffer;
  }
function program60(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                  <li>\n                    <a\n                      class=\"edit_assignment icon-edit\"\n                      id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_edit_item\"\n                      aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "edit_assignment_name_a8f7fae1", "Edit Assignment %{name}", options) : helperMissing.call(depth0, "t", "edit_assignment_name_a8f7fae1", "Edit Assignment %{name}", options)))
    + "\"\n                      data-focus-returns-to=\"assign_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n                    >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "edit_c5fbea07", "Edit", options) : helperMissing.call(depth0, "t", "edit_c5fbea07", "Edit", options)))
    + "</a>\n                  </li>\n                ";
  return buffer;
  }

function program62(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                  <li>\n                    <a\n                      class=\"edit_assignment icon-edit disabled\"\n                      id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_edit_item\"\n                      aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "edit_assignment_name_a8f7fae1", "Edit Assignment %{name}", options) : helperMissing.call(depth0, "t", "edit_assignment_name_a8f7fae1", "Edit Assignment %{name}", options)))
    + "\"\n                      aria-disabled=\"true\"\n                    >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "edit_c5fbea07", "Edit", options) : helperMissing.call(depth0, "t", "edit_c5fbea07", "Edit", options)))
    + "</a>\n                    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "you_do_not_have_permissions_to_edit_this_moderated_3195294f", "You do not have permissions to edit this moderated assignment", options) : helperMissing.call(depth0, "t", "you_do_not_have_permissions_to_edit_this_moderated_3195294f", "You do not have permissions to edit this moderated assignment", options)))
    + "</span>\n                  </li>\n                ";
  return buffer;
  }

function program64(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canEdit), {hash:{},inverse:self.program(67, program67, data),fn:self.program(65, program65, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ";
  return buffer;
  }
function program65(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                    <li>\n                      <a\n                        class=\"icon-quiz\"\n                        id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_build_item\"\n                        aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "build_name_41ba9e7a", "Build %{name}", options) : helperMissing.call(depth0, "t", "build_name_41ba9e7a", "Build %{name}", options)))
    + "\"\n                        data-focus-returns-to=\"assign_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n                        href=\"";
  if (helper = helpers.htmlBuildUrl) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.htmlBuildUrl); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n                      >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "build_78955b82", "Build", options) : helperMissing.call(depth0, "t", "build_78955b82", "Build", options)))
    + "</a>\n                    </li>\n                  ";
  return buffer;
  }

function program67(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                    <li>\n                      <a\n                        class=\"icon-quiz disabled\"\n                        id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_build_item\"\n                        aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "build_name_41ba9e7a", "Build %{name}", options) : helperMissing.call(depth0, "t", "build_name_41ba9e7a", "Build %{name}", options)))
    + "\"\n                        data-focus-returns-to=\"assign_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n                        href=\"";
  if (helper = helpers.htmlBuildUrl) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.htmlBuildUrl); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n                      >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "build_78955b82", "Build", options) : helperMissing.call(depth0, "t", "build_78955b82", "Build", options)))
    + "</a>\n                      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "you_do_not_have_permissions_to_build_this_moderate_bd5d350a", "You do not have permissions to build this moderated assignment", options) : helperMissing.call(depth0, "t", "you_do_not_have_permissions_to_build_this_moderate_bd5d350a", "You do not have permissions to build this moderated assignment", options)))
    + "</span>\n                    </li>\n                  ";
  return buffer;
  }

function program69(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <li>\n                  <a\n                    class=\"duplicate_assignment icon-copy-course\"\n                    id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_duplicate_item\"\n                    aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "duplicate_assignment_name_3ca7d753", "Duplicate Assignment %{name}", options) : helperMissing.call(depth0, "t", "duplicate_assignment_name_3ca7d753", "Duplicate Assignment %{name}", options)))
    + "\"\n                    data-focus-returns-to\"assign_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n                  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "duplicate_31cec192", "Duplicate", options) : helperMissing.call(depth0, "t", "duplicate_31cec192", "Duplicate", options)))
    + "</a>\n                </li>\n                ";
  return buffer;
  }

function program71(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <li>\n                  <a\n                    class=\"move_assignment icon-updown\"\n                    id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_move_item\"\n                    aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "move_assignment_name_aa253f26", "Move Assignment %{name}", options) : helperMissing.call(depth0, "t", "move_assignment_name_aa253f26", "Move Assignment %{name}", options)))
    + "'\n                    data-focus-returns-to=\"assign_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n                  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "move_to_9b91c6e0", "Move To…", options) : helperMissing.call(depth0, "t", "move_to_9b91c6e0", "Move To…", options)))
    + "</a>\n                </li>\n                ";
  return buffer;
  }

function program73(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <li>\n                  <a\n                    class=\"move_assignment icon-updown disabled\"\n                    id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_move_item\"\n                    aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "move_assignment_name_aa253f26", "Move Assignment %{name}", options) : helperMissing.call(depth0, "t", "move_assignment_name_aa253f26", "Move Assignment %{name}", options)))
    + "'\n                    aria-disabled=true\n                  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "move_to_9b91c6e0", "Move To…", options) : helperMissing.call(depth0, "t", "move_to_9b91c6e0", "Move To…", options)))
    + "</a>\n                </li>\n                ";
  return buffer;
  }

function program75(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <li>\n                  <a\n                    href=\"";
  if (helper = helpers.htmlEditUrl) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.htmlEditUrl); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "?return_to=";
  if (helper = helpers.return_to) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.return_to); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "#mastery-paths-editor\"\n                    class=\"edit_mastery_paths icon-mastery-path\"\n                    id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_edit_item_mastery_paths\"\n                    aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "edit_assignment_name_mastery_paths_40b50541", "Edit Assignment %{name} Mastery Paths", options) : helperMissing.call(depth0, "t", "edit_assignment_name_mastery_paths_40b50541", "Edit Assignment %{name} Mastery Paths", options)))
    + "\"\n                    data-focus-returns-to=\"assign_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n                    title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "edit_mastery_paths_for_name_c9fc59f9", "Edit Mastery Paths for %{name}", options) : helperMissing.call(depth0, "t", "edit_mastery_paths_for_name_c9fc59f9", "Edit Mastery Paths for %{name}", options)))
    + "\"\n                  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "mastery_paths_cc4096c2", "Mastery Paths", options) : helperMissing.call(depth0, "t", "mastery_paths_cc4096c2", "Mastery Paths", options)))
    + "</a>\n                </li>\n                ";
  return buffer;
  }

function program77(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n              <li>\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canDelete), {hash:{},inverse:self.program(80, program80, data),fn:self.program(78, program78, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              </li>\n            ";
  return buffer;
  }
function program78(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                  <a\n                    class=\"delete_assignment icon-trash\"\n                    id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_delete_item\"\n                    aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "delete_assignment_name_deec56e3", "Delete Assignment %{name}", options) : helperMissing.call(depth0, "t", "delete_assignment_name_deec56e3", "Delete Assignment %{name}", options)))
    + "\"\n                    data-focus-returns-to=\"assign_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n                  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "assignments.assignment_list_item.delete", "Delete", options) : helperMissing.call(depth0, "t", "assignments.assignment_list_item.delete", "Delete", options)))
    + "</a>\n                ";
  return buffer;
  }

function program80(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                  <a\n                    class=\"delete_assignment icon-trash disabled\"\n                    id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_delete_item\"\n                    aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "delete_assignment_name_deec56e3", "Delete Assignment %{name}", options) : helperMissing.call(depth0, "t", "delete_assignment_name_deec56e3", "Delete Assignment %{name}", options)))
    + "\"\n                    aria-disabled=true\n                  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "assignments.assignment_list_item.delete", "Delete", options) : helperMissing.call(depth0, "t", "assignments.assignment_list_item.delete", "Delete", options)))
    + "</a>\n                ";
  return buffer;
  }

function program82(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <li>\n                <a\n                    class=\"send_assignment_to icon-user\"\n                    id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_share_user\"\n                    aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "send_assignment_name_to_another_user_e2ca494d", "Send Assignment %{name} to another user", options) : helperMissing.call(depth0, "t", "send_assignment_name_to_another_user_e2ca494d", "Send Assignment %{name} to another user", options)))
    + "\"\n                >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "send_to_b940900a", "Send To...", options) : helperMissing.call(depth0, "t", "send_to_b940900a", "Send To...", options)))
    + "</a>\n              </li>\n              <li>\n                <a\n                  class=\"copy_assignment_to icon-duplicate\"\n                  id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_settings_copy_to\"\n                  aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "copy_assignment_name_to_another_course_b62d0a54", "Copy Assignment %{name} to another course", options) : helperMissing.call(depth0, "t", "copy_assignment_name_to_another_course_b62d0a54", "Copy Assignment %{name} to another course", options)))
    + "\"\n                >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_list_item")
  },data:data},helper ? helper.call(depth0, "copy_to_64f8456b", "Copy To...", options) : helperMissing.call(depth0, "t", "copy_to_64f8456b", "Copy To...", options)))
    + "</a>\n              </li>\n            ";
  return buffer;
  }

function program84(depth0,data) {
  
  var stack1;
  stack1 = self.invokePartial(partials['ui/shared/external-tools/jst/_external_tools_menu.handlebars'], 'ui/shared/external-tools/jst/_external_tools_menu.handlebars', (depth0 && depth0.menu_tools), helpers, partials, data);
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }

function program86(depth0,data) {
  
  
  return "<form data-view=\"edit-assignment\" class=\"form-dialog\"></form>";
  }

  buffer += "<div\n  id=\"assignment_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n  class=\"ig-row ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.canManage), (depth0 && depth0.published), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.canManage), (depth0 && depth0.published), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.is_master_course_master_content), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n  data-item-id=\"";
  if (helper = helpers.labelId) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.labelId); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isDuplicating), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n<div id=\"assignment_student_peer_review_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  